import { ActionReducerMap } from "@ngrx/store";
import { SAPReducer } from "./sap-reducers";
import { pendingChangesReducer } from "app/core/store/reducers/pending-changes.reducers";
import { excelConnectorCurrentReducer } from "./excel-connector-current.reducers";

export const MANAGE_SAP_CP_REDUCER: ActionReducerMap<ISAPGCPState> = {
    sapCPConfiguration: SAPReducer

};
